<template>
  <section class="map">
    <div id="allmap" ref="Emap" class="Bmap" />
    <section class="healthy-warning">
      <van-tabs v-model="active" :line-width="30" :line-height="2" title-active-color="#2a9cf2" color="#2a9cf2" @click="tabClick">
        <van-tab title="未处理" />
        <van-tab title="已提醒" />
      </van-tabs>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="tips"
        class="listbox"
        @load="getList"
      >
        <van-swipe-cell v-for="(item,index) in list" :key="index" class="unresolve" :name="item.id" :on-close="beforColse">
          <div class="sosItem" @click="setMarket(item)">
            <img v-lazy="userhandUrl" class="images">
            <div class="content">
              <div class="user">
                <p>{{ index }}{{ username }}</p>
                <p class="main">
                  {{ item.testTime }}
                </p>
              </div>
              <div class="time">
                求救位置：{{ $t('viewBase.a83') }}：{{ item.lat }}&nbsp; {{ $t('viewBase.a82') }}：{{ item.lng }}
              </div>
            </div>
          </div>
          <template #right>
            <van-button square type="danger" text="处理" />
          </template>
        </van-swipe-cell>
      </van-list>
    </section>
  </section>
</template>
<script>
import formDate from '@/utils/timeFormat'
import { healthHistorySos, delectHealthSos } from '@/api/health-sos'

export default {
  name: 'Sos',
  data() {
    return {
      tips: '',
      finished: false,
      loading: false,
      show: false,
      rightWidth: 65,
      list: [],
      ak: 'ZX17e9cCRYnH4Q5myih4Zw0tgEgpsiZo',
      active: 'Sos',
      currPopup: false,
      prePopup: true,
      formDate,
      position: {},
      Vmap: null,
      timer: null,
      count: 0,
      params: {
        page: 1,
        row: 5,
        accountId: 1,
        ishandle: false,
        read: false
      },
      username: '',
      zoom: 15,
      center: {},
      point: null,
      map: null,
      market: null,
      userhandUrl: ''
    }
  },
  created() {
    this.username = this.$route.params.name
    this.userhandUrl = this.$route.params.headUrl
    this.params = { ...this.params, ...this.$route.params }
    // this.point = { lng: this.params.lng, lat: this.params.lat }
  },
  mounted() {
    // this.Vmap = new window.BMap.Map(this.$refs.Emap)
    this.center.lng = this.params.lng
    this.center.lat = this.params.lat
    this.handler()
  },
  methods: {
    positionHandle() {
      this.$toast.loading({
        message: '正在寻址',
        duration: 300
      })
    },
    tabClick(value) {
      this.params.page = 1
      switch (value) {
        case 0:
          this.params.read = false
          this.getList()
          break
        case 1:
          this.params.read = true
          this.getList()
          break
      }
    },
    handler: function() {
/* eslint-disable */
      this.map = new BMap.Map('allmap')
      this.point = new BMap.Point(this.center.lng, this.center.lat)
      this.map.centerAndZoom(this.point, 15)
      this.marker = new BMap.Marker(this.point) // 创建点
      // this.marker.setLanguage('en')
      this.map.addOverlay(this.marker) // 将标注添加到地图中
      this.marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
/* eslint-disable */
    },
    async getList() {
      try {
        const res = await healthHistorySos(this.params)
        const list = res.data.data
        if (this.params.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.loading = false
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
        this.finished = list.length <this.params.row
        this.params.page++
        if(this.list.length>0){
          this.center = { lng: this.list[0].lng, lat: this.list[0].lat }
        }else{
          this.center = { lng: this.params.lng, lat: this.params.lat }
        }
      } catch (error) {
        console.log(error)
      }
    },
    setMarket(item) {
      this.positionHandle()
      this.map.clearOverlays(); 
      this.point = new BMap.Point(item.lng, item.lat)
      this.map.centerAndZoom(this.point, 15);   
      this.marker = new BMap.Marker(this.point) // 创建点
      this.map.addOverlay(this.marker) // 将标注添加到地图中
      this.marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画 
    },
    beforColse(clickPosition, instance) {
      switch (clickPosition) {
        case 'right':
          instance.close()
          delectHealthSos({ id: instance.name }).then(() => {
            this.list = this.list.filter(item=>{
              return item.id!==instance.name
            })
            this.$toast(this.$t('viewBase.a77'));
          }).catch(() => {
            this.$toast(this.$t('viewBase.a94'));
            // this.$router.push({ name: 'friendSos', params: id })
          })
          break;
      }
    }
  }
}
</script>
<style scoped lang="scss">
.map{
   width: 100%;
  height: calc( 100vh - 42px);
  overflow: hidden;
  position: fixed;
  bottom: 0;
}
#allmap{
  height:calc( 100vh - 200px);
  width:100%;
}
</style>

<style lang="scss">
  .mapPopup {
    border-radius: 15px 15px 0 0;
    height: 75vh;
  }
  .map-addresss {
    padding: 10px 15px;
  }
  .map-address {
    text-align: left;
    padding: 10px 0;
    border-bottom: 1px solid #ececec;
    .time {
      font-size: 12px;
      color: #666;
    }
    .desc {
      font-size: 15px;
      margin-top: 5px;
      color:#000;
    }
    .meta {
      font-size: 12px;
      color: #666;
      margin-top: 10px;
    }
  }
  .map-address:nth-last-of-type(1) {
    border: none;
  }
</style>
<style scoped lang="scss">
.unresolve {
  width:100vw;
  .van-swipe-cell__right {
    color: #fff;
    font-size: 15px;
    text-align: center;
    background-color: #f44;
    .van-button--square{
      height:100%;

    }
  }
  .van-swipe-cell__left {
    color: #fff;
    font-size: 15px;
    width: 65px;
    height: 88px;
    display: inline-block;
    text-align: center;
    line-height: 88px;
    background-color: #0066ff;
  }
  &::after{
    content:'';
    width:100%;
    height:1px;
    background:#ccc;
    position:absolute;
    bottom:0px;
  }
}
.sosItem{
  // width: 100%;
  height:80px;
  padding:15px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;

  .content{
    width: 100%;
    .user{
      width: 100%;
      display:flex;
      justify-content: space-between;
    }
    p{
      text-align: left;
      color:#333;
      font-size:14px;
      margin:5px 0 0;
    }
    .main{
      color:#999;
       font-size: 12px;
    }
    .time{
      color:#999;
       font-size: 12px;
       margin-top:7px;
       text-align: left;
    }
  }

}
.images{
  width:50px;
  height:50px;
  border-radius: 50%;
 margin-right:10px;
 flex:none;
}
.text{
  width:80%;
  border:1px solid #999;
  border-radius: 10px;
  height:auto;
  padding:15px;
  margin:15px auto;
}
.text1{
  padding:5px;
}
.handle {
    background: #ccc;
    color: #fff;
    text-align: center;
    // line-height: 81px;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.healthy-warning{
  width: 100%;
  min-height: 50px;
  height: auto;
  max-height:300px;
  position: fixed;
  bottom: 0px;
  z-index:99;
  background:#fff;
  overflow-y: auto; 
  padding-bottom:50px;
}
/deep/.van-tabs__nav--line {
    padding-bottom: 0rem;
    position: fixed;
    width: 100vw;
    z-index: 9;
    height:59px;

}
/deep/.van-tabs__line{
transform: translateX(300%) translateX(-50%);
}
/deep/.van-tabs--line .van-tabs__wrap{
    height: 59px;
}
.unresolve:nth-last-of-type(1){
    background:red;
  }
</style>


